import React from 'react';
import { Settings, Clock } from 'lucide-react';

/**
 * Секция настроек алгоритма хеширования
 */
const HashSettingsSection = ({
  formData,
  handleInputChange,
  errors
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/50 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Settings className="w-5 h-5 mr-2 text-blue-500" />
        Настройки алгоритма хеширования
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Количество раундов */}
        <div>
          <div className="flex items-center mb-1">
            <Clock className="w-4 h-4 mr-2 text-blue-500" />
            <label htmlFor="rounds" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Количество раундов (сложность)
            </label>
          </div>
          <input
            type="number"
            id="rounds"
            name="rounds"
            value={formData.rounds}
            onChange={handleInputChange}
            min="4"
            max="31"
            className={`form-input w-full ${errors.rounds ? 'input-error' : ''}`}
            aria-invalid={errors.rounds ? "true" : "false"}
          />
          {errors.rounds && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.rounds}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Большее значение = сильнее защита, но дольше время генерации
          </p>
        </div>

        {/* Тип хеша */}
        <div>
          <label htmlFor="hashFormat" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Формат хеша
          </label>
          <select
            id="hashFormat"
            name="hashFormat"
            value={formData.hashFormat}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            <option value="bcrypt">Bcrypt (современный, $2b$)</option>
            <option value="bcrypt_compat">Bcrypt совместимый ($2a$)</option>
            <option value="bcrypt_y">Bcrypt (вариант Y, $2y$)</option>
          </select>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Различия в вариантах для обратной совместимости
          </p>
        </div>
      </div>

      <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-3">
        <div className="p-3 bg-blue-50 dark:bg-blue-900/20 rounded border border-blue-100 dark:border-blue-800">
          <div className="text-center">
            <div className="text-xs text-blue-700 dark:text-blue-300 mb-1">Стандартный уровень</div>
            <div className="text-lg font-semibold text-blue-800 dark:text-blue-200 mb-1">10 раундов</div>
            <div className="text-xs text-blue-600 dark:text-blue-400">Рекомендуется для большинства случаев</div>
          </div>
        </div>
        
        <div className="p-3 bg-green-50 dark:bg-green-900/20 rounded border border-green-100 dark:border-green-800">
          <div className="text-center">
            <div className="text-xs text-green-700 dark:text-green-300 mb-1">Повышенная защита</div>
            <div className="text-lg font-semibold text-green-800 dark:text-green-200 mb-1">12 раундов</div>
            <div className="text-xs text-green-600 dark:text-green-400">Для важных данных</div>
          </div>
        </div>
        
        <div className="p-3 bg-purple-50 dark:bg-purple-900/20 rounded border border-purple-100 dark:border-purple-800">
          <div className="text-center">
            <div className="text-xs text-purple-700 dark:text-purple-300 mb-1">Максимальная защита</div>
            <div className="text-lg font-semibold text-purple-800 dark:text-purple-200 mb-1">14+ раундов</div>
            <div className="text-xs text-purple-600 dark:text-purple-400">Для критически важных систем</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HashSettingsSection;